<template>
  <section class="hero" id="identification">
    <div class="hero-inner">
      <div class="hero-media">
        <img :src="imageSrc" alt="Tarjeta" class="media-img" />
      </div>

      <div class="hero-copy">
        <h1 class="hero-title">
          TENER TODO<br />
          EN UN MISMO<br />
          <span class="hero-title-strong">LUGAR</span>
        </h1>

        <p class="hero-text">
          Somos una empresa enfocada en la creación electrónica de tarjetas digitales,
          donde podrás usar tu celular como tarjeta y compartir tus datos a un clic o a
          través de NFC y código QR.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutHero",
  props: {
    imageSrc: { type: String, default: require("@/assets/IMG/3.webp") },
  },
};
</script>

<style scoped>
.hero {
  position: relative;
  min-height: 640px;
  padding: 50px 0 0;
  display: flex;
  align-items: stretch;
  justify-content: center;
  scroll-margin-top: 89px;
  overflow: visible;
  background: #050505;
  margin: 0;
  background-image: url("@/assets/IMG/NOSOTROS.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.hero-inner {
  width: min(1200px, 92%);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(30px, 4vw, 80px);
  align-items: stretch;
  height: 100%;
}

.hero-media {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 500px;
}

.media-img {
  position: absolute;
  bottom: -98px;
  left: 50%;
  transform: translateX(-50%);
  width: min(1000px, 125%);
  height: 600px;
  object-fit: contain;
  display: block;
  pointer-events: none;
}

.hero-copy {
  color: #fff;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hero-title {
  margin: 0 0 -10px 0;
  font-family: "TT Chocolates", sans-serif;
  text-transform: uppercase;
  line-height: 0.9;
  font-weight: 300;
  letter-spacing: 2px;
  font-size: clamp(40px, 5.5vw, 85px);
}

.hero-title-strong {
  font-family: "Trial", sans-serif;
  font-weight: 700;
  letter-spacing: 3px;
  font-size: 1.25em;
  display: inline-block;
}

.hero-text {
  margin: 30px 0 0 0;
  font-family: "TT Chocolates", sans-serif;
  font-weight: 300;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.86);
  font-size: 23px;
  max-width: 520px;
  margin-left: auto;
}

@media (max-width: 900px) {
  .hero {
    padding-top: 70px;
    min-height: auto;
  }

  .hero-inner {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }

  .hero-copy {
    text-align: center;
    order: -1;
  }

  .hero-media {
    order: 1;
    min-height: 400px;
  }

  .hero-text {
    margin: 40px auto 0;
  }

  .media-img {
    position: relative;
    bottom: 0;
    width: min(100%, 90%);
    height: 400px;
  }
}
</style>
